import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import { useForm } from "react-hook-form";
import Inputs from "../../share/input/Inputs";
import { Step } from "@material-ui/core";

const WithdrawPriceModal = ({ close, step, setStep }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  return (
    <div className="relative">
      <button
        onClick={() => {
          close(false);
          setStep(0);
        }}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className="text-center text-[#77498F] mb-16">تسویه حساب</h3>
      <form onSubmit={handleSubmit()}>
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Name",
            },
          }}
          type="text"
          name="name"
          control={control}
          placeholder="مبلغ مورد درخواست*"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[20rem]"
        />
        <div className="flex flex-row items-center gap-8 justify-end">
          <BtnAlternative
            className="py-[2rem] px-[4rem] flex mr-auto"
            text="مرحله قبل"
            onClick={() => setStep(step - 1)}
          />
          <BtnPrimary
            className="py-[2rem] px-[4rem] flex"
            text="تایید و تسویه حساب"
            onClick={() => setStep(step + 1)}
          />
        </div>
      </form>
    </div>
  );
};

export default WithdrawPriceModal;
